module.exports = __webpack_public_path__ + "img/04i-Shop_651.db214872.jpg";